import * as AcademicTranscriptList from '../js/academic_transcripts_list-js.js'
//
// dropzone.js
// Theme module
//

'use strict';

(function() {

  //
  // Variables
  //

  var toggle = document.querySelectorAll('[data-toggle="academic-transcripts-dropzone');


  //
  // Functions
  //

  function globalOptions() {
    Dropzone.autoDiscover = false;
  }

  function init(el) {
    var currentFile = undefined;
    var options = {
      url: $("#academic_transcripts_upload").data("direct-upload-url"),
      autoProcessQueue: false,
      uploadMultiple: true, 
      maxFiles: 20,
      acceptedFiles:"image/png,image/jpeg,image/jpg,application/pdf",
      createImageThumbnails: false,
      previewsContainer: false,
      init: function() {
        this.on('addedfile', function(file) {
          uploadFile(file);
        });
      }
    }

    // Init dropzone
    new Dropzone(el, options);
  }

  const uploadFile = (file) => {
    // your form needs the file_field direct_upload: true, which
    //  provides data-direct-upload-url
    const url = $("#academic_transcripts_upload").data("direct-upload-url")
    const upload = new ActiveStorage.DirectUpload(file, url)
   
    upload.create((error, blob) => {
      if (error) {
      } else {
        var data = {'students':{'academic_transcripts_blob':blob.signed_id}}
        $.ajax({
          type: "POST",
          beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
          url: "/students/academic_transcripts/create",
          dataType: "json",
          data: data,
          success: function(data){
            if($(".academic_transcript_list_item").length == 0){
              AcademicTranscriptList.create_new_academic_transcript_list(data);
            }else{
              AcademicTranscriptList.add_to_academic_transcript_list(data);
            }
            
          }
        });
      }
    })
  }

  //
  // Events
  //

  if (typeof Dropzone !== 'undefined' && toggle) {
    globalOptions();

    [].forEach.call(toggle, function(el) {
      init(el);
    });
  }

})();